import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  IconButton,
  Snackbar,
  Paper,
  Table,
  TableSortLabel,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  ButtonGroup,
  CircularProgress,
  Breadcrumbs,
  HomeIcon,
  FormControl,
  Select,
  InputLabel,
  MuiAlert,
  MenuItem,
  NavLink,
  makeStyles,
  withStyles,
  useTheme,
  commonService,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  AddBoxIcon,
  SearchIcon,
  ClearIcon,
  AddIcon,
  OutlinedInput,
  PropTypes,
} from "../../../common";
import rightArrow from "../../../assets/images/right-arrow.svg";
import RewardIcon from "../../../assets/images/commission-icon.svg";

import FilterListIcon from "@material-ui/icons/FilterList";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "5rem",
  },
  formControl: {
    margin: theme.spacing(1),
  },
  selectEmpty: {},
  margin: {
    margin: theme.spacing(1),
  },
  link: {
    display: "flex",
    textDecoration: "none",
  },
  icon: {
    marginRight: theme.spacing(0.5),
    width: 20,
    height: 20,
  },
  breadcrumbIcon: { width: 15, paddingRight: theme.spacing(0.5) },
  listIcon: { width: 20, paddingRight: theme.spacing(0.5) },

  btnStyle: {
    backgroundColor: "#1DBF73",
    color: "white",
    fontWeight: "400",
    "&:hover": {
      backgroundColor: "#11a962",
    },
  },
  table: {
    marginTop: "1.5rem",
    overflowX: "auto",
  },
  scroller: {
    overflowX: "scroll",
  },
  red: {
    color: "#FC2861",
  },
  green: {
    color: "#1DBF73",
  },
  level: {
    fontSize: "0.625rem",
    padding: "0.0625rem 0.125rem",
    border: "1px solid",
    color: "#1DBF73",
    backgroundColor: "#1DBF731A",
    borderColor: "#1DBF73",
    borderRadius: "20px",
    margin: "0 0 0 5px",
  },
  hyphen: {
    display: "flex",
    width: "1.125rem",
    height: "auto",
    objectFit: "contain",
    padding: "0 2px 0 2px",
  },
  senderChargeWrap: {
    position: "relative",
  },
  senderCharge: {
    position: "absolute",
    top: "-0.9375rem",
    right: "-0.625rem",
    fontSize: "0.875rem",
  },

  partyTypeWrap: {
    position: "relative",
  },

  partyType: {
    position: "absolute",
    top: "-2.1875rem",
    right: "-1.5625rem",
    fontSize: "0.875rem",
  },
  partiesWrap: {
    display: "flex",
    flexDirection: "row",
  },
  active: {
    border: "1px solid #1DBF73",
    textTransform: "Capitalize",
    color: "#1DBF73",
    backgroundColor: "#1DBF7333",
  },
  disabled: {
    border: "1px solid #1DBF73",
    textTransform: "Capitalize",
    color: "#BEBDBD",
  },
  basicInfo: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "#7A7878",
  },
  rowPadding: {
    padding: "0.125rem 0.25rem",
  },
  pr3: {
    paddingRight: "3px",
  },
  pr5: { paddingRight: "5px" },
  btnIcon: {
    paddingRight: "5px",
    fontSize: "20px",
  },
}));
const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "asc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: "id",
    numeric: true,
    disablePadding: false,
    label: "ID",
  },
  {
    id: "title",
    numeric: true,
    disablePadding: false,
    label: "Title",
  },
  {
    id: "parties",
    numeric: true,
    disablePadding: false,
    label: "Parties",
  },
  {
    id: "transactionType",
    numeric: true,
    disablePadding: false,
    label: "Transaction Type",
  },
  {
    id: "amount",
    numeric: true,
    disablePadding: false,
    label: "Amount",
  },
  {
    id: "reward",
    numeric: true,
    disablePadding: false,
    label: "Reward",
  },
  {
    id: "starting_time",
    numeric: true,
    disablePadding: false,
    label: "Starting Time",
  },
  {
    id: "ending_time",
    numeric: true,
    disablePadding: false,
    label: "Ending Time",
  },
  {
    id: "created_at",
    numeric: true,
    disablePadding: false,
    label: "Created At",
  },
  {
    id: "status",
    numeric: true,
    disablePadding: false,
    label: "Status",
  },
];

function EnhancedTableHead(props) {
  const {
    // classes,
    //  onSelectAllClick,
    order,
    orderBy,
    //   numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            style={{
              fontWeight: "500",
              color: "#2B335E",
              fontSize: "1.125rem",
              paddingLeft: "0",
              overflowWrap: "normal",
            }}
            key={headCell.id}
            align={headCell.numeric ? "left" : "right"}
            padding={headCell.disablePadding ? "default" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "desc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {/* {orderBy === headCell.id ? (
                    <span>
                      {order === "desc" ? "sorted descending" : "sorted ascending"}
                    </span>
                  ) : null} */}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  // classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

export default function RewardList() {
  const classes = useStyles();
  const classes1 = useStyles1();
  const theme = useTheme();
  const [userType, setUserType] = useState([]);
  const [transactionTypeList, setTransactionTypeList] = useState([]);
  const [rewardList, setRewardList] = useState([]);
  const [count, setCount] = React.useState(20);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [sender, setSender] = useState("");
  const [senderlevelType, setSenderLevelType] = useState([]);
  const [receiverlevelType, setReceiverLevelType] = useState([]);
  const [senderLevel, setSenderLevel] = useState("");
  const [receiverLevel, setReceiverLevel] = useState("");
  const [transactionType, setTransactionType] = useState("");
  const [receiver, setReceiver] = useState("");
  const [fromAmount, setFromAmount] = useState("");
  const [toAmount, setToAmount] = useState("");
  const [user, setUser] = useState("");
  const [errorMsgBody, setErrorMsgBody] = useState("");
  const [successMsgBody, setSuccessMsgBody] = useState("");
  const [error, setError] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [dataTableIsLoading, setDataTableIsLoading] = React.useState(true);
  const [selected, setSelected] = React.useState([]);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("id");
  const [status, setStatus] = useState("");

  const [filterShow, setFilterShow] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleErrorClose = (event) => {
    setError(false);
  };

  const handleSearch = async () => {
    setDataTableIsLoading(true);
    setRewardList([]);
    const res = await commonService.getRewardsList(
      page,
      sender,
      receiver,
      transactionType,
      fromAmount,
      toAmount,
      senderLevel,
      receiverLevel,
      status
    );
    if (res.code === 200 && res.data.rewards.length === 0) {
      setError(true);
      setErrorMsgBody("No Data Found");
      setDataTableIsLoading(false);
    } else if (res.code === 200) {
      setRewardList(res && res.data && res.data.rewards);
      console.log("reward", res.data.rewards);
      setDataTableIsLoading(false);
    } else {
      setError(true);
      setErrorMsgBody(res.messages);
      setDataTableIsLoading(false);
    }
  };

  const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.common.white,
      fontSize: "1.125rem",
      letterSpacing: "0.014375rem",
      fontWeight: "500",
      color: "#2B335E",
    },
    body: {
      fontSize: "0.875rem",
      height: "4rem",
    },
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
      //   padding: '5px 10px',
    },
  }))(TableRow);

  const TablePaginationActions = (props) => {
    const { count, page, rowsPerPage, onChangePage } = props;

    const handleBackButtonClick = (event) => {
      setRewardList([]);

      onChangePage(event, page - 1);

      commonService
        .getRewardsList(
          page - 1,
          sender,
          receiver,
          transactionType,
          fromAmount,
          toAmount,
          senderLevel,
          receiverLevel
        )
        .then((body) => {
          if (body.code === 200) {
            setRewardList(body && body.data && body.data.data);
          } else {
          }
        });
    };

    const handleNextButtonClick = (event) => {
      setRewardList([]);
      setCount(count + parseInt(20));
      onChangePage(event, page + 1);
      commonService
        .getRewardsList(
          page + 1,
          sender,
          receiver,
          transactionType,
          fromAmount,
          toAmount,
          senderLevel,
          receiverLevel
        )
        .then((body) => {
          if (body.code === 200) {
            setRewardList(body && body.data && body.data.data);
          } else {
          }
        });
    };

    return (
      <div className={classes1.root}>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
      </div>
    );
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rewardList.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 15));
    setPage(0);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const emptyRows =
    rowsPerPage -
    Math.min(rowsPerPage, rewardList && rewardList.length - page * rowsPerPage);

  const clearFormInput = () => {
    setSender("");
    setReceiver("");
    setTransactionType("");
    setFromAmount("");
    setToAmount("");
    setSenderLevel("");
    setReceiverLevel("");
    setStatus("");
  };

  const rewardInactiveHandler = async (e, id, status) => {
    let requestObj = {
      reward_id: id,
      status: status,
    };
    const res = await commonService.updateRewards(requestObj);
    res?.code === 200 && setOpen(true);
    setSuccessMsgBody(res.messages);
    handleSearch();
    res?.code !== 200 && setError(true);
    setErrorMsgBody(res.messages);
  };

  const getUserTypes = async () => {
    const userType = await commonService.getUserType();
    setUserType(userType.data?.user_types);
  };

  useEffect(() => {
    getUserTypes();
    handleSearch();
  }, []);

  const getTransactionTypeList = async (sender, receiver) => {
    const transactionType = await commonService.getTransactionTypeCharge(
      sender,
      receiver
    );
    setTransactionTypeList(transactionType.data?.transaction_types);
  };

  const getSenderLevelsList = async (sender_user_type_id) => {
    const senderlevelType = await commonService.getLevel(sender_user_type_id);
    setSenderLevelType(senderlevelType.data?.levels);
  };

  const getReceiverLevelsList = async (receiver_user_type_id) => {
    const receiverlevelType = await commonService.getLevel(
      receiver_user_type_id
    );
    setReceiverLevelType(receiverlevelType.data?.levels);
  };

  return (
    <Container maxWidth="xl" className={classes.root}>
      <Snackbar
        open={open}
        autoHideDuration={1500}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleClose} severity="success">
          {successMsgBody}
        </Alert>
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={error}
        autoHideDuration={1500}
        onClose={handleErrorClose}
      >
        <Alert onClose={handleErrorClose} severity="error">
          {errorMsgBody}
        </Alert>
      </Snackbar>
      <Breadcrumbs style={{ marginTop: "10px" }} aria-label="breadcrumb">
        <NavLink
          style={{ color: "#2B335E99" }}
          to="/dashboard"
          className={classes.link}
        >
          <HomeIcon className={classes.icon} />
          Home
        </NavLink>
        <NavLink
          style={{ color: "#2B335E99" }}
          to="/receiver-reward/view-all"
          className={classes.link}
        >
          {/* <WhatshotIcon className={classes.icon} /> */}
          <img
            className={classes.breadcrumbIcon}
            // style={{ width: '20%', marginBottom: '3%' }}
            src={RewardIcon}
          />
          Receiver Reward
        </NavLink>
        <Typography style={{ color: "#2B335E" }} className={classes.link}>
          <AddBoxIcon className={classes.listIcon} /> List
        </Typography>
      </Breadcrumbs>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          style={{
            textAlign: "left",
            margin: "15px 0",
            color: "#2B335E",
            fontSize: "25px",
          }}
        >
          Receiver Rewards List
        </Typography>
        <div>
          <NavLink
            to="/receiver-reward/create"
            variant="contained"
            style={{ height: "30px", textDecoration: "none", float: "right" }}
          >
            <Button
              className="btn btn-primary btn-block"
              size="medium"
              variant="contained"
            >
              <AddIcon className={classes.pr5} /> Create Receiver Reward
            </Button>
          </NavLink>
          <Button
            size="medium"
            variant="contained"
            color="primary"
            className="btn btn-primary"
            style={{ float: "right", marginRight: 10 }}
            onClick={(e) => setFilterShow(!filterShow)}
          >
            <FilterListIcon style={{ paddingRight: "5px" }} />
          </Button>
        </div>
      </div>

      {filterShow && (
        <Paper style={{ padding: "20px" }}>
          <Typography
            style={{
              textAlign: "left",
              marginBottom: "10px",
              fontSize: "1.125rem",
              letterSpacing: "0.23px",
              fontWeight: "500",
              color: "#2B335E",
            }}
          >
            Filter By:
          </Typography>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.formControl}
                size="small"
                id="sender"
              >
                <InputLabel id="demo-simple-select-filled-label">
                  Sender is
                </InputLabel>
                <Select
                  labelid="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  value={sender}
                  onChange={(e) => {
                    setSender(e.target.value);
                    if (e.target.value !== "") {
                      getSenderLevelsList(e.target.value);
                      if (receiver !== "") {
                        getTransactionTypeList(e.target.value, receiver);
                      }
                    }
                  }}
                  label="Sender is"
                >
                  <MenuItem value="">
                    <span>None</span>
                  </MenuItem>
                  {userType.map((user) => (
                    <MenuItem key={user.id} value={user.id}>
                      {user.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.formControl}
                size="small"
                id="sender"
              >
                <InputLabel id="demo-simple-select-filled-label">
                  (Level) Sender is of
                </InputLabel>
                <Select
                  labelId="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  value={senderLevel}
                  onChange={(e) => {
                    setSenderLevel(e.target.value);
                  }}
                  label="(Level) Sender is of"
                  name="senderLevel"
                >
                  <MenuItem value="">
                    <span>None</span>
                  </MenuItem>
                  {senderlevelType.map((user) => (
                    <MenuItem value={user.id}>{user.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.formControl}
                size="small"
                id="fromAmount"
              >
                <InputLabel id="demo-simple-select-filled-label">
                  From Amount
                </InputLabel>
                <OutlinedInput
                  fullWidth
                  label="From Amount"
                  id="outlined-adornment-amount"
                  type="text"
                  inputComponent="input"
                  value={fromAmount}
                  onChange={(e) => setFromAmount(e.target.value)}
                />
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.formControl}
                size="small"
                label="Receiver is"
                id="receiver"
              >
                <InputLabel id="demo-simple-select-filled-label">
                  Receiver
                </InputLabel>
                <Select
                  labelid="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  value={receiver}
                  label="Receiver"
                  onChange={(e) => {
                    setReceiver(e.target.value);
                    if (e.target.value !== "") {
                      getReceiverLevelsList(e.target.value);
                      if (sender !== "") {
                        getTransactionTypeList(sender, e.target.value);
                      }
                    }
                  }}
                >
                  <MenuItem value="">
                    <span>None</span>
                  </MenuItem>
                  {userType.map((user) => (
                    <MenuItem key={user.id} value={user.id}>
                      {user.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.formControl}
                size="small"
                id="receiver"
              >
                <InputLabel id="demo-simple-select-filled-label">
                  (Level) Receiver is of
                </InputLabel>
                <Select
                  labelId="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  value={receiverLevel}
                  onChange={(e) => {
                    setReceiverLevel(e.target.value);
                  }}
                  label="(Level) Receiver is of"
                  name="receiverLevel"
                >
                  <MenuItem value="">
                    <span>None</span>
                  </MenuItem>
                  {receiverlevelType.map((user) => (
                    <MenuItem value={user.id}>{user.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.formControl}
                size="small"
                id="toAmount"
              >
                <InputLabel id="demo-simple-select-filled-label">
                  To Amount
                </InputLabel>
                <OutlinedInput
                  labelid="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  value={toAmount}
                  label="To Amount"
                  onChange={(e) => setToAmount(e.target.value)}
                ></OutlinedInput>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.formControl}
                size="small"
                id="transactionType"
              >
                <InputLabel id="demo-simple-select-filled-label">
                  Transaction Type
                </InputLabel>
                <Select
                  label="Transaction Type"
                  labelid="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  value={transactionType}
                  onChange={(e) => setTransactionType(e.target.value)}
                >
                  <MenuItem value="">
                    <span>None</span>
                  </MenuItem>
                  {transactionTypeList.map((user) => (
                    <MenuItem key={user.id} value={user.id}>
                      {user.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl
                variant="outlined"
                fullWidth
                className={classes.formControl}
                size="small"
                id="transactionType"
              >
                <InputLabel id="demo-simple-select-filled-label">
                  Status
                </InputLabel>
                <Select
                  label="Status"
                  labelid="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <MenuItem value="1">Active</MenuItem>
                  <MenuItem value="0">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Divider style={{ margin: "10px 0" }} />
          <Grid
            item
            container
            xl={12}
            justify="flex-end"
            alignItems="flex-end"
            className={classes.btnContainer}
          >
            <Box mr={5}>
              <Button
                variant="contained"
                className={classes.cancelBtn}
                onClick={clearFormInput}
              >
                <ClearIcon className={classes.btnIcon} /> Clear
              </Button>
            </Box>
            <Box mr={3} mt={2}>
              <Button
                variant="contained"
                color="secondary"
                className="btn btn-primary btn-block"
                onClick={handleSearch}
              >
                <SearchIcon className={classes.btnIcon} />
                Filter
              </Button>
            </Box>
          </Grid>
        </Paper>
      )}

      {dataTableIsLoading ? (
        <Box mt={15}>
          <CircularProgress
            size={80}
            className={classes.progress}
            thickness={2}
          />
        </Box>
      ) : (
        <TableContainer component={Paper} className={classes.table}>
          {rewardList && rewardList.length > 0 && (
            <>
              <Table
                aria-labelledby="tableTitle"
                size="small"
                padding="default"
                aria-label="simple table"
                style={{ width: "100%" }}
              >
                <EnhancedTableHead
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={rewardList && rewardList.length}
                />

                <TableBody>
                  {rewardList &&
                    rewardList.length > 0 &&
                    stableSort(rewardList, getComparator(order, orderBy))
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((item, index) => {
                        const isItemSelected = isSelected(item.id);
                        return (
                          <StyledTableRow
                            hover
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            selected={isItemSelected}
                            key={item.id}
                            style={{
                              cursor: "pointer",
                              overflowWrap: "anywhere",
                            }}
                          >
                            <StyledTableCell style={{ overflowWrap: "normal" }}>
                              {item.id}
                            </StyledTableCell>
                            <StyledTableCell style={{ overflowWrap: "normal" }}>
                              {item.title ? item.title : "N/A"}
                            </StyledTableCell>
                            <StyledTableCell
                              className={classes.rowPadding}
                              style={{ overflowWrap: "normal" }}
                            >
                              {" "}
                              <Grid
                                container
                                item
                                xs={12}
                                className={classes.basicInfo}
                              >
                                <Grid item xs={5}>
                                  {item && item.sender_user_type}
                                  <sup className={classes.green}>
                                    {" "}
                                    {item && item.sender_level}
                                  </sup>
                                </Grid>
                                <Grid item xs={2}>
                                  <img
                                    className={classes.hyphen}
                                    alt="hyphen"
                                    src={rightArrow}
                                  />
                                </Grid>

                                <Grid item xs={5}>
                                  {item && item.receiver_user_type}
                                  <sup className={classes.green}>
                                    {" "}
                                    {item && item.receiver_level}
                                  </sup>
                                </Grid>
                              </Grid>
                            </StyledTableCell>

                            <StyledTableCell
                              className={classes.rowPadding}
                              style={{ overflowWrap: "normal" }}
                            >
                              {item.transaction_type}
                            </StyledTableCell>
                            <StyledTableCell
                              className={classes.rowPadding}
                              style={{ overflowWrap: "normal" }}
                            >
                              {" "}
                              <Grid
                                container
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                xl={12}
                                className={classes.basicInfo}
                              >
                                <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  md={12}
                                  lg={6}
                                  xl={5}
                                >
                                  <span className={classes.pr3}>
                                    {item && item.currency_code}
                                  </span>
                                  <strong>
                                    {item && item.amount_range_from}
                                  </strong>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  md={12}
                                  lg={6}
                                  xl={2}
                                >
                                  <img
                                    className={classes.hyphen}
                                    alt="hyphen"
                                    src={rightArrow}
                                  />
                                </Grid>

                                <Grid
                                  item
                                  xs={12}
                                  sm={12}
                                  md={12}
                                  lg={6}
                                  xl={5}
                                >
                                  <strong>
                                    {" "}
                                    {item && item.amount_range_to}
                                  </strong>
                                </Grid>
                              </Grid>
                            </StyledTableCell>
                            <StyledTableCell
                              className={classes.rowPadding}
                              style={{ overflowWrap: "normal" }}
                            >
                              <Grid
                                container
                                item
                                spacing={1}
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                xl={12}
                                className={classes.basicInfo}
                              >
                                <Grid item xs={5}>
                                  Receiver
                                  <sup className={classes.red}>
                                    {item && item.slab_type == "f"
                                      ? `${item && item.amount}TK`
                                      : `${item && item.amount}%`}
                                  </sup>
                                </Grid>
                                {/* <span style={{ padding: "0 8px", display: "flex" }}>
                              |
                            </span> */}

                                {/* <Grid item xs={5}>
                                    Receiver
                                    <sup className={classes.red}>
                                      {item && item.receiver_slab_type == "F"
                                        ? item && item.receiver_charge
                                        : `${item && item.receiver_charge}%`}
                                    </sup>
                                  </Grid> */}
                              </Grid>
                            </StyledTableCell>
                            <StyledTableCell style={{ overflowWrap: "normal" }}>
                              {item.starting_time}
                            </StyledTableCell>
                            <StyledTableCell style={{ overflowWrap: "normal" }}>
                              {item.ending_time}
                            </StyledTableCell>
                            <StyledTableCell style={{ overflowWrap: "normal" }}>
                              {item.created_at}
                            </StyledTableCell>
                            <StyledTableCell style={{ overflowWrap: "normal" }}>
                              {item.status == "Active" ? (
                                <ButtonGroup
                                  size="small"
                                  aria-label="small outlined button group"
                                >
                                  <Button className={classes.active}>
                                    Active
                                  </Button>
                                  <Button
                                    className={classes.disabled}
                                    onClick={(e) =>
                                      rewardInactiveHandler(e, item.id, 0)
                                    }
                                  >
                                    Inactive
                                  </Button>
                                </ButtonGroup>
                              ) : (
                                <ButtonGroup
                                  size="small"
                                  aria-label="small outlined button group"
                                >
                                  <Button
                                    className={classes.disabled}
                                    onClick={(e) =>
                                      rewardInactiveHandler(e, item.id, 1)
                                    }
                                  >
                                    Active
                                  </Button>
                                  <Button className={classes.active}>
                                    Inactive
                                  </Button>
                                </ButtonGroup>
                              )}
                            </StyledTableCell>
                          </StyledTableRow>
                        );
                      })}

                  {emptyRows > 0 && (
                    <StyledTableRow style={{ height: 33 * emptyRows }}>
                      <StyledTableCell colSpan={12} />
                    </StyledTableRow>
                  )}
                </TableBody>
              </Table>

              <TablePagination
                //  showfirstbutton="true"
                //  showlastbutton="true"
                component="div"
                count={rewardList.length}
                pagesize={15}
                rowsPerPageOptions={[10, 20, 50]}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                SelectProps={{
                  inputProps: { "aria-label": "rows per page" },
                  native: true,
                }}
                ActionsComponent={TablePaginationActions}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </>
          )}

          {/* Not found */}

          {rewardList && rewardList.length <= 0 && (
            <Table
              aria-labelledby="tableTitle"
              size="small"
              padding="default"
              aria-label="simple table"
            >
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={rewardList && rewardList.length}
              />

              <TableBody>
                <StyledTableRow>
                  <StyledTableCell style={{ backgroundColor: "white" }}>
                    <h6 className="p-4">No data found!</h6>
                  </StyledTableCell>
                </StyledTableRow>
              </TableBody>
            </Table>
          )}

          {/* <TablePagination
                showfirstbutton="true"
                showlastbutton="true"
                component="div"
                count={count}
                pagesize={15}
                rowsPerPageOptions={[]}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={handleChangePage}
                SelectProps={{
                  inputProps: { "aria-label": "rows per page" },
                  native: true,
                }}
                ActionsComponent={TablePaginationActions}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              /> */}
        </TableContainer>
      )}
    </Container>
  );
}
